import React, { useState } from "react";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "jalali-moment";

import { useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { DatePicker } from "zaman";

import HeadBefore from "./HeadBefore";
const requestFirstInfo = async (data) => {
  const current = new Date().toISOString().split("T")[0];

  // console.log("i log in request methos ....");

  /*let res = await api.post('users/register/',data={data}
    // console.log(res)
    // console.log("*****************************************************************")
    */

  let res = await axios.post(
    "https://api.talaeshow.com/api/users/register/",
    (data = { data })
  );

  return res;
};

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export default function SendInformation() {
  const [error, seterror] = useState({ first: "", futher: "" });
  const [futher, setfuther] = useState("");
  const [islog, setIsLog] = useState(false);
  const [choose, setChoose] = useState("first");
  const [email, setEmail] = useState("");
  const [birthday, setBirthday] = useState();
  var IsDigit = new RegExp(/^[0-9]/);
  var IsSheba = new RegExp(/^[0-9]/);
  const [errorin, seterrorin] = useState({
    codeMeli: "",
    card: "",
    sheba: "",
    mobile: "",
    email: "",
  });
  const [errorp, setErrorp] = useState("");
  const [flag, setflag] = useState(false);
  const current = new Date().toISOString().split("T")[0];
  const navigate = useNavigate();
  var phone = "";
  var destination = "";
  let otp = "";
  try {
    const location = useLocation();
    destination = location.state.destination;
    otp = location.state.otp;
    if (destination.includes("@")) {
      // console.log("run loop set email .....");
    } else {
      phone = destination;
    }
  } catch {
    // console.log("erroooor");
  }

  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [password, setPassword] = useState("");
  const [card, setCard] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [melicode, setMelicode] = useState("");
  const [sheba, setSheba] = useState("");
  const [referral_code, setReferralCode] = useState("");
  const [meliImage, setMeliImage] = useState("");
  const [meliUrl, setMeliUrl] = useState("");

  const [isNext, setIsNext] = useState(false);

  const styles = {
    calendarContainer: "calendarContainer",
    dayPickerContainer: "dayPickerContainer",
    monthsList: "monthsList",
    daysOfWeek: "daysOfWeek",
    dayWrapper: "dayWrapper",
    selected: "selected",
    heading: "heading",
  };
  function changepage(event) {
    event.preventDefault();

    if (!fname || !lname || !password) {
      toast.error("لطفا تمام موارد خواسته شده پر شود");
      return;
    }
    setIsNext(true);

    let formData = new FormData();

    formData.append("mobile_number", phone);
    formData.append("email", destination.includes("@") ? destination : email);

    formData.append("first_name", fname);
    formData.append("last_name", lname);

    formData.append("password", password);
    formData.append("verify_code", otp);
    formData.append("invited_code", referral_code);

    axios({
      url: "https://api.talaeshow.com/api/users/register/",
      method: "POST",
      headers: {
        // Add any auth token here
      },

      // Attaching the form data
      data: formData,
    })
      .then((res) => {
        setIsNext(false);

        if (res.data.access) {
          localStorage.setItem("token", res.data.access);
          setChoose("futher");
        } else {
          toast.error(res.data.detail);
        }
      })
      .catch((error) => {});
  }

  function Gotohome(e) {
    e.preventDefault();
    let formData = new FormData();

    formData.append("mobile_number", phone);
    formData.append("email", email);

    formData.append("first_name", fname);
    formData.append("last_name", lname);

    formData.append("password", password);
    formData.append("verify_code", otp);
    formData.append("invited_code", "");
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: "https://api.talaeshow.com/api/users/register/",
      method: "POST",
      headers: {},
      data: formData,
    })
      .then((res) => {
        setIsLoading(false);
        if (res.data.access) {
          localStorage.setItem("token", res.data.access);
          navigate("/");
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  function handlechoose() {
    setChoose("futher");
  }

  function handlechoosefirst() {
    setChoose("first");
  }

  function just_persian(str) {
    var p = /^[\u0600-\u06FF\s]+$/;
    if (str == "") {
      return true;
    }
    if (!p.test(str)) {
      toast.error("لطفا کیبورد خود را به فارسی تبدیل کنید");

      return false;
    }
    return true;
  }

  function just_english(str) {
    var p = /^[\u0600-\u06FF\s]+$/;
    if (str == "") {
      return true;
    }
    if (!p.test(str)) {
      return true;
    }

    toast.error("لطفا کیبورد خود را به انگلیسی تبدیل کنید");
    return false;
  }

  function handleSubmitAll(event) {
    event.preventDefault();

    let formData = new FormData();
    let bank = [
      {
        sheba_code: `IR${sheba}`,
        bank_card: card,
      },
    ];
    formData.append("bank_info[0]sheba_code", `IR${sheba}`);

    formData.append("national_code", melicode);
    formData.append("birth_date", birthday);
    formData.append("card_number", card);
    formData.append("card_image", meliImage);

    let token = localStorage.getItem("token");
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: "https://api.talaeshow.com/api/users/profile/",
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: formData,
    })
      .then((res) => {
        setIsLoading(false);
        if (res.status == 201) {
          navigate("/");
        } else {
          toast.error(res.data.detail);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error("خطایی از سمت سرور پیش آمده است مجددا امتحان کنید");
        // console.log(error);
      });
  }

  function deleteImage(event) {
    setMeliImage("");
    setMeliUrl("");
  }

  function notNowBtn() {
    navigate("/");
  }
  function handleBirth(value) {
    value = formatDate(value.value);
    value = moment(value, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD");
    value = value.replace("/", "-");
    value = value.replace("/", "-");
    setBirthday(value);
    // console.log(value);
  }

  function checkCodeMeli(code) {
    var L = code.length;

    if (L < 8 || parseInt(code, 10) == 0) return false;
    code = ("0000" + code).substr(L + 4 - 10);
    if (parseInt(code.substr(3, 6), 10) == 0) return false;
    var c = parseInt(code.substr(9, 1), 10);
    var s = 0;
    for (var i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);
    s = s % 11;
    return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
    return true;
  }

  function handelCheck(event) {
    event.preventDefault();
    var tagName = event.target.name;
    let p = event.target.value;

    if (tagName == "mobile") {
      var pattern = new RegExp(/^09[0-9]{9}/);

      if (!pattern.test(p)) {
        seterrorin({
          ...error,
          mobile: "لطفا شماره تلفن خود را درست وارد نمایید",
        });
      } else if (p.length == 11) {
        seterrorin({ ...error, mobile: "" });
        phone = p;
      } else {
        seterrorin({
          ...error,
          mobile: "لطفا شماره تلفن خود را درست وارد نمایید",
        });
      }
    } else if (tagName == "email") {
      var pattern1 = new RegExp(/^\S+@\S+\.\S+/);
      var pattern = /\S+@\S+\.\S+/;

      if (pattern.test(p)) {
        seterrorin({ ...error, email: "" });
        setEmail(p);
      } else {
        seterrorin({ ...error, email: "لطفا ایمیل خود را درست وارد نمایید" });
      }
    }

    if (tagName == "meli" && event.target.files[0]) {
      // console.log("meli image validations.....");
      let file = event.target.files[0];
      if (file.size > 10240000) {
        return;
      }

      setMeliUrl(URL.createObjectURL(event.target.files[0]));

      setMeliImage(event.target.files[0]);
    } else if (tagName == "codemeli") {
      // console.log("meli code validations.....");

      setMelicode(p);

      let res = checkCodeMeli(p);

      if (res) {
        seterrorin({ ...errorin, codeMeli: "" });
      } else {
        seterrorin({
          ...errorin,
          codeMeli: "لطفا کد ملی خود را به درستی وارد نمایید",
        });
      }
    } else if (tagName == "card") {
      setCard(p);
      // console.log("in card validations .....");
      if (IsDigit.test(p)) {
        if (p.length == 16) {
          seterrorin({ ...error, card: "" });
        } else {
          seterrorin({
            ...error,
            card: "شماره کارت خود را به درستی وارد نمایید",
          });
        }
      } else {
        seterrorin({
          ...error,
          card: "شماره کارت خود را به درستی وارد نمایید",
        });
      }
    } else if (tagName == "sheba") {
      // console.log("sheba validation .......");
      setSheba(p);

      // console.log(p);

      if (IsSheba.test(p) && p.length == 24) {
        seterrorin({ ...error, sheba: "" });
        setSheba(p);
      } else {
        seterrorin({
          ...error,
          sheba: "شماره شبا خود را به درستی وارد نمایید",
        });
      }
    }
  }

  function handlepass(event) {
    let pass = event.target.value;

    if (!just_english(pass)) {
      return;
    }
    var re = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");

    let valid = re.test(pass);

    if (valid) {
      setErrorp("");
    } else if (pass == "") {
      setErrorp("");
    } else {
      setErrorp("رمزعبور ضعیف !");
    }

    setPassword(pass);
  }

  return (
    <>
      <div>
        <HeadBefore />
        <form className="text-center pt-5 mt-5">
          <h3 className="title-for-login title-for-login-desktop">
            ثبت نام در طلایی شو
          </h3>
          <div className="container">
            <div className="row justify-content-center h-100 section-padding align-items-center">
              <div className="col-xl-6 col-md-8">
                <div className="row">
                  <div className="col-6 text-end">
                    <button
                      type="button"
                      id={"first"}
                      name="first"
                      className={
                        "btn-choose btn-330" +
                        (choose === "first" ? "" : " not-active-login")
                      }
                      onClick={handlechoosefirst}
                    >
                      اطلاعات اولیه
                    </button>
                  </div>

                  <div className="col-6 text-end">
                    <button
                      type="button"
                      id={"futher"}
                      name="futher"
                      className={
                        "btn-choose btn-331" +
                        (choose === "futher" ? "" : " not-active-login")
                      }
                      onClick={handlechoose}
                    >
                      اطلاعات تکمیلی
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="authincation section-padding">
            <div className="container h-100">
              <div className="row justify-content-center h-100 align-items-center">
                <div className="col-xl-6 col-md-8">
                  <div className="mini-logo text-center my-2"></div>
                  <div className="auth-form  custom-shadow">
                    <form className={"mt-4"}>
                      {choose == "first" ? (
                        <>
                          <div className="form-group mt-3 text-end mytitle-323">
                            <div className="mt-2 mb-2">
                              <div className="signup-title-box">
                                امکانات
                                <b> پایه </b>
                                برای افرادی که ثبت‌نام اولیه انجام می‌دهند:
                              </div>
                              <div className="signup-list-items">
                                <div>
                                  <img
                                    src={"/images/svg/checkmark.svg"}
                                    alt=""
                                  />
                                  خرید تا سقف ۱۰ میلیون تومان
                                </div>
                                <div>
                                  <img
                                    src={"/images/svg/checkmark.svg"}
                                    alt=""
                                  />
                                  شارژ نامحدود کیف پول
                                </div>
                              </div>
                            </div>
                            <div className="input-group pt-1"></div>

                            <div className={"text-danger h6 text-large"}>
                              {error.first}
                            </div>
                          </div>

                          <div className="form-group text-end mytitle-323">
                            <div className="row">
                              <div className="col-12">
                                <div className="invite-code-extra">
                                  <span className="label-for-extra-info">
                                    کد دعوت از دوستان
                                  </span>
                                  <input
                                    name="referral_code"
                                    id={"referral_code"}
                                    className="w-100 text-muted form-input-custom"
                                    value={referral_code}
                                    onChange={(e) =>
                                      setReferralCode(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="signup-subtitle-box">
                              ثبت‌ نامه اولیه را انجام دهید:
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <span className="d-flex pe-2 pb-1">نام *</span>
                                <input
                                  name="name"
                                  id={"firstname"}
                                  className="form-input-custom max-100"
                                  value={fname}
                                  onChange={(e) =>
                                    setFname(
                                      just_persian(e.target.value)
                                        ? e.target.value
                                        : fname
                                    )
                                  }
                                />
                              </div>

                              <div className="col-6 ">
                                <span className="d-flex pe-2 pb-1">
                                  نام خانوادگی *
                                </span>
                                <input
                                  name="name"
                                  id={"lastname"}
                                  className="form-input-custom w-100 max-100"
                                  value={lname}
                                  onChange={(e) =>
                                    setLname(
                                      just_persian(e.target.value)
                                        ? e.target.value
                                        : lname
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="w-100 pt-2 pb-2">
                              <span className="d-flex pe-2 pb-1">موبایل *</span>
                              {phone ? (
                                <input
                                  name="mobile"
                                  id={"mobile"}
                                  className="form-input-custom w-100 text-muted"
                                  value={phone}
                                  readOnly={true}
                                />
                              ) : (
                                <>
                                  <input
                                    name="mobile"
                                    id={"mobile"}
                                    className="form-input-custom w-100"
                                    onChange={handelCheck}
                                  />

                                  {errorin.mobile ? (
                                    <span className="text-small text-danger padding-5612">
                                      {errorin.mobile}
                                    </span>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </div>
                            <div className="w-100 pt-2 pb-2">
                              <span className="d-flex pe-2 pb-1">ایمیل </span>
                              {destination && destination.includes("@") ? (
                                <input
                                  name="email"
                                  id={"email"}
                                  className="form-input-custom w-100 text-muted"
                                  value={destination}
                                />
                              ) : (
                                <>
                                  <input
                                    name="email"
                                    id={"email2"}
                                    className="form-input-custom w-100"
                                    onChange={handelCheck}
                                  />

                                  {errorin.email ? (
                                    <span className="text-small text-danger padding-5612">
                                      {errorin.email}
                                    </span>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </div>
                            <div className="w-100 pt-2 pb-2">
                              <span className="d-flex pe-2 pb-1">
                                رمزعبور *
                              </span>
                              <input
                                type="password"
                                name="password"
                                id={"password"}
                                value={password}
                                className="form-input-custom w-100 mb-1"
                                onChange={handlepass}
                              />
                              {errorp ? (
                                <>
                                  <span className="text-small text-danger padding-5612">
                                    {errorp}
                                  </span>

                                  <br />
                                </>
                              ) : (
                                <></>
                              )}

                              <span className="password-alert-box">
                                رمز باید حداقل ۸ حرفی، شامل حروف بزرگ و کوچک
                                انگلیسی و عدد باشد
                              </span>
                            </div>
                            <div className="row mt-4 mb-1">
                              <div className="col-6">
                                <button
                                  className="form-input-button-custom"
                                  disabled={!fname || !lname || !password}
                                  onClick={Gotohome}
                                >
                                  {isLoading ? (
                                    <img
                                      src={"./loading.svg"}
                                      alt={""}
                                      className={"w-loading"}
                                    />
                                  ) : (
                                    <>بعدا” ثبت نام میکنم</>
                                  )}
                                </button>
                              </div>

                              <div className="col-6">
                                <button
                                  className="btn form-input-button-custom text-white btn-6464 spinner-button"
                                  id="submit"
                                  data-loading-text="<i className='fas fa-spinner fa-pulse'></i>"
                                  onClick={changepage}
                                >
                                  {isNext ? (
                                    <img
                                      src={"./loading.svg"}
                                      alt={""}
                                      className={"w-loading"}
                                    />
                                  ) : (
                                    <>مرحله بعد</>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="form-group mt-3 text-end mytitle-323">
                            <div className="mt-2 mb-2">
                              <div className="signup-title-box">
                                امکانات
                                <b> ویژه </b>
                                برای افرادی که ثبت‌نام تکمیلی انجام می‌دهند:
                              </div>
                              <div className="signup-list-items">
                                <div>
                                  <img
                                    src={"/images/svg/checkmark.svg"}
                                    alt=""
                                  />
                                  سقف نامحدود برای خرید
                                </div>
                                <div>
                                  <img
                                    src={"/images/svg/checkmark.svg"}
                                    alt=""
                                  />
                                  شارژ نامحدود کیف پول
                                </div>
                                <div>
                                  <img
                                    src={"/images/svg/checkmark.svg"}
                                    alt=""
                                  />
                                  فروش طلای موجود در صندوق
                                </div>
                                <div>
                                  <img
                                    src={"/images/svg/checkmark.svg"}
                                    alt=""
                                  />
                                  دریافت حضوری شمش طلا
                                </div>
                              </div>
                            </div>

                            <div className={"text-danger h6 text-large"}>
                              {error.futher}
                            </div>
                          </div>

                          <div className="form-group mt-3 text-end mytitle-323">
                            <div className="title h5">اطلاعات تکمیلی</div>

                            <br />

                            <div className="w-100 pt-2 pb-2">
                              <span className="d-flex pe-2 pb-1">کد ملی *</span>
                              <input
                                name="codemeli"
                                id={"codemeli"}
                                className="form-input-custom w-100"
                                value={melicode}
                                onChange={handelCheck}
                              />
                              {errorin.codeMeli ? (
                                <span className="text-small text-danger padding-5612">
                                  {errorin.codeMeli}
                                </span>
                              ) : (
                                <span className="text-small text-muted padding-5612">
                                  کد ملی باید مطابق با نام و نام خانوادگی باشد
                                </span>
                              )}
                            </div>

                            <div className="w-100 pt-2 pb-2">
                              <span className="d-flex pe-2 pb-1">
                                کارت بانکی
                              </span>
                              <input
                                name="card"
                                id={"card"}
                                className="form-input-custom w-100"
                                value={card}
                                onChange={handelCheck}
                              />

                              {errorin.card ? (
                                <span className="text-small text-danger padding-5612">
                                  {errorin.card}
                                </span>
                              ) : (
                                <span className="text-small text-muted padding-5612">
                                  کارت بانکی باید مطابق با نام و نام خانوادگی
                                  باشد
                                </span>
                              )}
                            </div>

                            <div className="w-100 pt-2 pb-2">
                              <span className="d-flex pe-2 pb-1">
                                تاریخ تولد{" "}
                              </span>

                              <div className="g-flex-row">
                                <div className="d-child">
                                  <DatePicker onChange={handleBirth} />
                                </div>
                              </div>

                              {errorin.sheba ? (
                                <span className="text-small text-danger padding-5612">
                                  {errorin.sheba}
                                </span>
                              ) : (
                                <span className="text-small text-muted padding-5612">
                                  تاریخ تولد خود را وارد نمایید
                                </span>
                              )}
                            </div>

                            <div className="w-100 pt-2 pb-2">
                              <span className="d-flex pe-2 pb-1 melli-card-label">
                                تصویر کارت ملی
                              </span>
                              {meliUrl ? (
                                <div className="file-uploaded ">
                                  <img
                                    data-display-toggle={meliUrl}
                                    src={meliUrl}
                                    className="imgfile"
                                    alt={""}
                                    onError={"this.style.display='none'"}
                                  />

                                  <div
                                    className="del-icon"
                                    onClick={deleteImage}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20.119"
                                      height="20.429"
                                      viewBox="0 0 390.119 482.429"
                                    >
                                      <g
                                        id="delete-button-svgrepo-com"
                                        transform="translate(-46.155)"
                                      >
                                        <g id="Group_400" data-name="Group 400">
                                          <path
                                            id="Path_585"
                                            data-name="Path 585"
                                            d="M381.163,57.8H306.069a65.283,65.283,0,0,0-129.7,0h-75.1a55.177,55.177,0,0,0-55.111,55.117v2.828a55.168,55.168,0,0,0,34.83,51.2V427.312A55.179,55.179,0,0,0,136.1,482.429H346.333a55.178,55.178,0,0,0,55.111-55.117V166.944a55.172,55.172,0,0,0,34.83-51.2v-2.828A55.179,55.179,0,0,0,381.163,57.8ZM241.214,26.139A39.232,39.232,0,0,1,279.657,57.8H202.778A39.228,39.228,0,0,1,241.214,26.139ZM375.3,427.312a29.011,29.011,0,0,1-28.973,28.979H136.1a29.012,29.012,0,0,1-28.973-28.979V170.861H375.3Zm34.83-311.568a29.011,29.011,0,0,1-28.973,28.979h-279.9a29.011,29.011,0,0,1-28.973-28.979v-2.828a29.011,29.011,0,0,1,28.973-28.979h279.9a29.011,29.011,0,0,1,28.973,28.979v2.828Z"
                                            fill="#707070"
                                          />
                                          <path
                                            id="Path_586"
                                            data-name="Path 586"
                                            d="M171.144,422.863A13.07,13.07,0,0,0,184.213,409.8V262.641a13.069,13.069,0,1,0-26.138,0V409.795A13.068,13.068,0,0,0,171.144,422.863Z"
                                            fill="#707070"
                                          />
                                          <path
                                            id="Path_587"
                                            data-name="Path 587"
                                            d="M241.214,422.863a13.071,13.071,0,0,0,13.07-13.068V262.641a13.07,13.07,0,1,0-26.139,0V409.795A13.069,13.069,0,0,0,241.214,422.863Z"
                                            fill="#707070"
                                          />
                                          <path
                                            id="Path_588"
                                            data-name="Path 588"
                                            d="M311.284,422.863A13.07,13.07,0,0,0,324.352,409.8V262.641a13.069,13.069,0,1,0-26.138,0V409.795A13.069,13.069,0,0,0,311.284,422.863Z"
                                            fill="#707070"
                                          />
                                        </g>
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                              ) : (
                                <div className="file-upload ">
                                  <div className="text-center">
                                    <div className="file-upload-bg">
                                      <img
                                        src={"/images/fileuploader.png"}
                                        alt={""}
                                      />
                                    </div>
                                  </div>
                                  <input
                                    type="file"
                                    name={"meli"}
                                    className="upload"
                                    id="upload-btn"
                                    onChange={handelCheck}
                                  />
                                </div>
                              )}
                            </div>

                            <div className="row">
                              <div>
                                <div className="row mt-4 mb-1">
                                  <div className="col-6">
                                    <button
                                      className="btn form-input-button-custom"
                                      onClick={notNowBtn}
                                    >
                                      فعلاً نه
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      className="btn form-input-button-custom spinner-button"
                                      data-loading-text="<i className='fas fa-spinner fa-pulse'></i>"
                                      onClick={handleSubmitAll}
                                    >
                                      {isLoading ? (
                                        <img
                                          src={"./loading.svg"}
                                          alt={""}
                                          className={"w-loading"}
                                        />
                                      ) : (
                                        <>ثبت نام</>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
